import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Partner from '@/components/Relation/Partner';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';


const PartnerPage: NextPage = () => {

  return (
    <>
      <NextSeo
        title='Green Parenting | Be Our Partner'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/partner"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/partner-desktop.jpg",
            width: 900,
            height: 922,
            alt: 'Green Parenting Be Our Partner image',
          }]
        }}
      />
      <Header />
      <Partner />
      <Footer />
    </>
  )
}

export default PartnerPage
